module.exports = __webpack_public_path__ + "static/media/corporate-catering-4.b3c7856f.jpg";